const roles = {
  CDS: 'CDS',
  CDS_NAME: 'CDS Administrator',
  SUPPLIER: 'Supplier',
  SUPPLIER_NAME: 'Supplier Administrator',
  CLIENT: 'Client',
  CLIENT_NAME: 'Client User',
};

export default roles;
